import { call, put, takeEvery } from "redux-saga/effects";
import { GET_COMPANY_FROM_URL, loginJsonBody } from "../../../components/Common/CommonFunction";
import { Company_Theme_List_API, delete_CompanyID, edit_CompanyID, fetch_CompanyList, getCompanyGroup, postSubmit_Company, updateCompany_ID } from "../../../helpers/backend_helper";
import {
  deleteCompanyIDSuccess,
  editCompanyIDSuccess,
  getCompanyListSuccess,
  getCompanyGroupSuccess,
  saveCompany_Success,
  updateCompanyIDSuccess,
  companyApiErrorAction,
  fetchCompanyThemeSuccess,
  fetchCompanyThemeError
} from "./actions";
import {
  DELETE_COMPANY_ID,
  EDIT_COMPANY_ID,
  FETCH_COMPANY_LIST,
  FETCH_COMPANY_THEME,
  GET_COMPANYGROUP,
  POST_COMPANY_SUBMIT,
  UPDATE_COMPANY_ID,
} from "./actionType";

function* Save_Method_ForCompany_GenFun({ config }) {

  try {
    const response = yield call(postSubmit_Company, config);
    yield put(saveCompany_Success(response));
  } catch (error) {
    yield put(companyApiErrorAction());
  }
}


function* Get_Company_List_GenFunc() {
  // getList API
  try {
    const response = yield call(fetch_CompanyList, JSON.stringify(loginJsonBody()));
    yield put(getCompanyListSuccess(response.Data));
  } catch (error) { yield put(companyApiErrorAction()) }
}

function* deleteCompany_ID({ config }) {                      // delete API
  try {
    const response = yield call(delete_CompanyID, config);
    yield put(deleteCompanyIDSuccess(response))
  } catch (error) { yield put(companyApiErrorAction()) }
}

function* editCompany_ID({ config }) {               //Edit API
  const { btnmode } = config;
  try {
    const response = yield call(edit_CompanyID, config);
    response.pageMode = btnmode
    yield put(editCompanyIDSuccess(response));
  } catch (error) { yield put(companyApiErrorAction()) }
}

function* update_Company({ config }) {             //Update API
  try {
    const response = yield call(updateCompany_ID, config);
    yield put(updateCompanyIDSuccess(response))
  } catch (error) { yield put(companyApiErrorAction()) }
}

/// CompanyGroupDropdown
function* CompanyGroup() {
  try {
    const response = yield call(getCompanyGroup);
    yield put(getCompanyGroupSuccess(response.Data));
  } catch (error) { yield put(companyApiErrorAction()) }
}

function* fetchCompanyThemeSaga({ payload }) {
  try {
    const response = yield call(Company_Theme_List_API, payload);

    if (response?.Status === true && response?.StatusCode === 200) {
      const Company = GET_COMPANY_FROM_URL()

      // ✅ store in sessionStorage
      sessionStorage.setItem("companyTheme", JSON.stringify(response.Data));
      sessionStorage.setItem("companyCode", response.Data.CompanyAbbreviation);


      localStorage.setItem(`${Company}_companyTheme`, JSON.stringify(response.Data));
      localStorage.setItem(`${Company}_companyCode`, response.Data.CompanyAbbreviation);

      yield put(fetchCompanyThemeSuccess(response.Data));

    } else if (response?.Status === false && response?.StatusCode === 404) {

      // ✅ remove from sessionStorage
      sessionStorage.removeItem("companyCode");
      sessionStorage.removeItem("companyTheme");

      yield put(fetchCompanyThemeError());
    } else {
      yield put(fetchCompanyThemeError());
    }

  } catch (error) {
    yield put(fetchCompanyThemeError());
  }
}

function* CompanySaga() {
  yield takeEvery(FETCH_COMPANY_LIST, Get_Company_List_GenFunc);
  yield takeEvery(EDIT_COMPANY_ID, editCompany_ID);
  yield takeEvery(POST_COMPANY_SUBMIT, Save_Method_ForCompany_GenFun);
  yield takeEvery(DELETE_COMPANY_ID, deleteCompany_ID);
  yield takeEvery(UPDATE_COMPANY_ID, update_Company);
  yield takeEvery(GET_COMPANYGROUP, CompanyGroup);
  yield takeEvery(FETCH_COMPANY_THEME, fetchCompanyThemeSaga);

}

export default CompanySaga;
